// Mock data para o site de rastreamento veicular

export const siteConfig = {
  companyName: 'GoProtege',
  phone: '5515991927177',
  address: 'Av. Fernando Stecca, 661 - Sorocaba/SP',
  city: 'Sorocaba/SP',
  whatsappDefault: 'Olá! Gostaria de solicitar uma cotação de rastreamento veicular em Sorocaba.'
};

export const navigationLinks = [
  { label: 'Sobre Nós', href: '#sobre-nos' },
  { label: 'Veículo Pessoal', href: '#pessoa-fisica' },
  { label: 'Frota Empresarial', href: '#frotas' },
  { label: 'Dúvidas', href: '#faq' }
];

export const heroFeatures = [
  { icon: 'Shield', text: 'Suporte 24h' },
  { icon: 'Zap', text: 'Instalação Rápida' },
  { icon: 'MapPin', text: 'Rastreamento Ativo' }
];

export const topBadges = [
  { icon: 'CheckCircle', text: 'Tecnologia Homologada' },
  { icon: 'Clock', text: 'Suporte 24 Horas' },
  { icon: 'Smartphone', text: 'App iOS e Android' },
  { icon: 'Building2', text: 'Empresa Especializada' },
  { icon: 'MapPin', text: 'Cobertura Nacional' },
  { icon: 'BookOpen', text: 'Guia Completo' }
];

export const goProtegeFeatures = [
  'Rastreamento veicular em tempo real 24h/dia',
  'Bloqueio remoto do veículo pelo aplicativo',
  'Alertas de cerca virtual, velocidade e ignição',
  'Aplicativo completo para Android e iOS',
  'Instalação no local do cliente em Sorocaba',
  'Suporte técnico local especializado',
  'Histórico de rotas de até 3 meses',
  'Cobertura nacional – funciona fora de Sorocaba',
  'Plataforma web + app para gestão de frotas',
  'Rastreador carro Sorocaba com tecnologia homologada'
];

export const pessoaFisicaFeatures = [
  {
    icon: 'MapPin',
    title: 'Localização em Tempo Real',
    description: 'Plataforma rápida com rastreamento GPS preciso. Saiba exatamente onde seu veículo está a qualquer momento, 24 horas por dia.'
  },
  {
    icon: 'Smartphone',
    title: 'App para Android e iOS',
    description: 'Aplicativo completo e intuitivo disponível para celular. Acesse todas as funções do rastreador diretamente do seu smartphone.'
  },
  {
    icon: 'Bell',
    title: 'Alertas Personalizados',
    description: 'Receba notificações de cerca virtual, excesso de velocidade, entrada e saída de zonas, e muito mais. Configure do jeito que preferir.'
  },
  {
    icon: 'ShieldOff',
    title: 'Bloqueio Remoto de Emergência',
    description: 'Em caso de furto ou roubo, bloqueie o motor do veículo remotamente pelo app. Aumenta as chances de recuperação em até 3x.'
  },
  {
    icon: 'Users',
    title: 'Segurança para Toda a Família',
    description: 'Monitore o veículo do cônjuge, dos filhos ou de qualquer familiar. Tenha paz de espírito sabendo que todos estão protegidos.'
  },
  {
    icon: 'Headphones',
    title: 'Suporte 24 Horas',
    description: 'Central de atendimento disponível a qualquer hora. Em Sorocaba, conte com suporte técnico local e equipe pronta para ajudar.'
  }
];

export const frotasFeatures = [
  {
    icon: 'Monitor',
    title: 'Monitoramento em Tempo Real',
    description: 'Visualize todos os veículos da sua frota em um único painel. Acompanhe posição, velocidade e status em tempo real.'
  },
  {
    icon: 'Route',
    title: 'Histórico de Rotas (3 meses)',
    description: 'Acesse o histórico completo de rotas percorridas por até 3 meses. Ideal para auditorias e comprovação de entregas.'
  },
  {
    icon: 'FileText',
    title: 'Relatórios Completos',
    description: 'Relatórios detalhados de percurso, jornada, paradas, excesso de velocidade e muito mais. Exportáveis em PDF ou Excel.'
  },
  {
    icon: 'TrendingDown',
    title: 'Redução de Custos Operacionais',
    description: 'Empresas em Sorocaba reduzem em média 20% os custos com combustível, manutenção e horas extras com nossa gestão de frotas.'
  },
  {
    icon: 'Wrench',
    title: 'Gestão de Manutenção',
    description: 'Sistema de alertas preventivos para manutenção programada. Evite paradas inesperadas e prolongue a vida útil da frota.'
  },
  {
    icon: 'Activity',
    title: 'Telemetria Avançada',
    description: 'Dados de comportamento do motorista: frenagens bruscas, acelerações abruptas, curvas em alta velocidade e mais.'
  }
];

export const testimonials = [
  {
    name: 'Carlos Eduardo S.',
    role: 'Proprietário de veículo',
    location: 'Sorocaba/SP – Zona Norte',
    text: 'Instalaram o rastreador na minha casa, sem precisar ir a oficina. Aplicativo excelente e suporte muito rápido. Finalmente tenho paz de espírito com meu carro.',
    rating: 5
  },
  {
    name: 'Fernanda A.',
    role: 'Proprietária de empresa',
    location: 'Sorocaba/SP – Centro',
    text: 'Contratamos para monitorar nossa frota de 5 veículos. Reduzimos muito o consumo de combustível e conseguimos ver onde cada carro está em tempo real. Recomendo!',
    rating: 5
  },
  {
    name: 'Ricardo Monteiro',
    role: 'Autônomo',
    location: 'Votorantim/SP',
    text: 'Meu veículo foi furtado e conseguimos recuperá-lo em menos de 2 horas graças ao bloqueio remoto e ao monitoramento 24h. Valeu cada centavo da mensalidade.',
    rating: 5
  },
  {
    name: 'Juliana B.',
    role: 'Mãe de família',
    location: 'Sorocaba/SP – Aparecidinha',
    text: 'Coloquei o rastreador no carro dos meus filhos. O app de cerca virtual avisa quando eles saem da área permitida. Serviço impecável e atendimento local ótimo.',
    rating: 5
  },
  {
    name: 'Paulo Henrique M.',
    role: 'Gerente de transportadora',
    location: 'Itu/SP',
    text: 'Os relatórios de telemetria ajudaram a identificar motoristas com comportamento de risco. Muito melhorou a gestão da nossa frota. Suporte sempre rápido.',
    rating: 5
  },
  {
    name: 'Marcos Vieira',
    role: 'Comerciante',
    location: 'Sorocaba/SP – Éden',
    text: 'Instalação rápida e sem complicação. O técnico foi pontual e explicou tudo sobre o funcionamento do app. Preço justo e serviço de qualidade.',
    rating: 5
  }
];

export const faqData = [
  {
    question: 'Como funciona o rastreamento veicular em Sorocaba?',
    answer: 'O rastreamento veicular em Sorocaba funciona por meio de um dispositivo GPS instalado discretamente no veículo. Esse dispositivo envia a localização em tempo real para nossos servidores, que são acessados pelo app no celular ou pela plataforma web. Você visualiza onde o veículo está, o histórico de rotas percorridas e recebe alertas personalizados — tudo em tempo real, 24 horas por dia.'
  },
  {
    question: 'O rastreador funciona fora de Sorocaba?',
    answer: 'Sim! Nosso sistema possui cobertura nacional completa. Você pode viajar para qualquer lugar do Brasil e continuar rastreando seu veículo normalmente. O rastreador funciona em todo território brasileiro.'
  },
  {
    question: 'Posso bloquear o veículo remotamente?',
    answer: 'Sim, oferecemos o recurso de bloqueio remoto do motor. Em caso de furto ou roubo, você pode bloquear o veículo diretamente pelo aplicativo, impedindo que ele seja ligado novamente. Este recurso aumenta significativamente as chances de recuperação.'
  },
  {
    question: 'Como é feita a instalação do rastreador em Sorocaba?',
    answer: 'A instalação é feita por nossa equipe técnica especializada, no local de sua preferência em Sorocaba e região. Você não precisa ir a uma oficina. O processo é rápido, geralmente leva cerca de 1 a 2 horas, e o técnico explica todo o funcionamento do sistema.'
  },
  {
    question: 'Precisa pagar mensalidade? Qual é o valor?',
    answer: 'Sim, há uma mensalidade para manter o serviço de monitoramento 24h, aplicativo, alertas e suporte técnico. O valor varia conforme o plano escolhido (pessoa física ou frota). Entre em contato para receber uma cotação personalizada para suas necessidades.'
  },
  {
    question: 'O rastreador é visível no veículo?',
    answer: 'Não. O dispositivo é instalado de forma discreta e oculta, sem deixar rastros visíveis. Isso aumenta a segurança, pois dificulta que terceiros saibam da existência do rastreador.'
  },
  {
    question: 'Qual a diferença entre rastreador e rastreador com bloqueio?',
    answer: 'O rastreador básico apenas monitora a localização do veículo. Já o rastreador com bloqueio, além do monitoramento, permite que você bloqueie o motor remotamente pelo aplicativo em caso de emergência. Recomendamos sempre a opção com bloqueio para maior segurança.'
  },
  {
    question: 'Atendem empresas com grandes frotas em Sorocaba?',
    answer: 'Sim! Temos soluções específicas para gestão de frotas de todos os tamanhos. Oferecemos plataforma web completa, relatórios detalhados, telemetria, gestão de manutenção e muito mais. Entre em contato para uma proposta personalizada.'
  }
];

export const relatedKeywords = [
  'Rastreamento Veicular Sorocaba',
  'Rastreador Veicular Sorocaba',
  'Rastreamento de Veículos Sorocaba',
  'Rastreamento para Frotas Sorocaba',
  'Rastreador com Bloqueio Sorocaba',
  'Rastreador Carro Sorocaba',
  'Empresa de Rastreamento Sorocaba',
  'Rastreamento Automotivo Sorocaba',
  'Rastreador Moto Sorocaba'
];
